import { OfficeList } from './OfficeList';

export const OfficeListVendor = () => <OfficeList readOnly onSave={async () => null} />;
